import { PropertyMetadata } from "@tylertech/tyler-api-types";
import { Utilities } from "@tylertech/shared-module";
import { CodeLookupService } from "../../../../services";
import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ODataFilterFactoryService } from "@tylertech/odata-module";

@Component({
    selector: "metadata-badge",
    templateUrl: "./metadata-badge.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MetadataBadgeComponent implements OnInit
{
    @Input()
    model: string;

    @Input()
    propertyMetadata: PropertyMetadata;

    @Input()
    formattedModel: string;

    constructor(
        private $codeLookupService: CodeLookupService,
        private readonly $odataFilterFactory: ODataFilterFactoryService
    ) { }

    loading: boolean = false;
    DEFAULT_THEME: string = "info-primary";
    ngOnInit(): void
    {
        const self = this;
        this.loading = true;
        this.getValue(this.model, this.propertyMetadata)
            .then(v =>
            {
                self.model = self.formattedModel;
                self.loading = false;
            });
    }

    getValue(value: any, property: PropertyMetadata): Promise<string>
    {
        if (Utilities.IsNullOrUndefined(value)) return Promise.resolve("");
        if (property.Lookup)
        {
            let fieldValue = "";
            const builder = this.$odataFilterFactory.createBuilder();
            builder.filterEQ("Key", value);
            return this.$codeLookupService.Get(property.Lookup, builder.build())
                .then(
                    x =>
                    {
                        if (x && x.length > 0) fieldValue = x[0].Value;
                        return fieldValue;
                    },
                    () =>
                    {
                        return "Error Loading";
                    }
                );
        }
        return Promise.resolve(value.toString());
    }

    get value(): string
    {
        return !Utilities.IsNullOrUndefinedOrEmpty(this.model) ? this.formattedModel : "n/a";
    }

    get theme(): string
    {
        return Utilities.IsNullOrUndefined(this.propertyMetadata.Theme) ? this.DEFAULT_THEME : this.propertyMetadata.Theme;
    }

    get showBadge(): boolean
    {
        return this.value.length > 0;
    }
}
